
import Input from "../Input";
import Output from "../Output";

import switchImage from "../../assets/switch.png";
import { Helmet } from 'react-helmet-async';


import { Link } from "react-router-dom";
import heber from "../../assets/heber.png";
import magyar from "../../assets/magyar.png";
import arrow from "../../assets/arrow.png"

function HeberMagyar({ handleText, output, handleTarget, handleSource, langs, handleSwap, handleTranslate, text }) {


    return (

        <>
            <Helmet>
                <title>Héber magyar fordító</title>
                <meta name='description' content="Ingyenes héber magyar fordító szavakra, kifejezésekre, mondatokra. Akár teljes szöveg fordítása is." />
                <meta title="Héber magyar fordító" />
                <link rel="canonical" href="https://online-fordito.hu/heber-magyar-fordito" />
            </Helmet>
            <h1>Héber magyar fordító</h1>
            <div className="wrapper">
                <div>
                    <Input handleText={handleText} handleSource={handleSource} langs={langs} text={text}></Input>
                    <button className="transbutton" onClick={handleTranslate}>Fordítás</button>
                </div>

                <button className="switch" onClick={handleSwap}><img src={switchImage}></img></button>


                <Output output={output} handleTarget={handleTarget} langs={langs} />

            </div>

            <section>

                <div className="sectionhead">
                    <h2>A héber nyelvről</h2>
                    <img src={heber} alt="Izraeli zászló"></img>
                </div>

                <p>A héber egy több ezer éves múltra visszatekintő, gazdag történelemmel rendelkező sémi nyelv. A judaizmusban szent nyelvnek számít, és a modern időkben újraéledt beszélt nyelvként. Ma a héber Izrael hivatalos nyelve, és világszerte több millióan beszélik.</p>


                <p>Az ősi héber, más néven bibliai héber, a héber Biblia (Tanakh) nyelve, amelyet az ókori Izraelben beszéltek. Ez egy erősen flektált nyelv, összetett nyelvtannal és igealakokkal. A héber írásmódja egyedi, és jobbról balra olvasható.</p>


                <p>A 19. század végén a héber nyelv a cionista mozgalom részeként figyelemre méltó újjáéledésen ment keresztül, ami a modern héber nyelv kialakulásához vezetett. Eliezer Ben-Yehuda jelentős szerepet játszott a nyelv modernizálásában és mindennapi használatra való adaptálásában. A modern héberre hatással van az ősi héber, de más nyelvek, köztük az arab, a jiddis és az európai nyelvek elemeit is magába foglalja.</p>


                <p>A modern héberre az ősi héberhez képest egyszerűbb nyelvtani szerkezet jellemző. Analitikus nyelvnek tekinthető, a szórend és a prepozíciók nagyobb szerepet játszanak a jelentés közvetítésében. A főneveknek, mellékneveknek és igéknek különböző alakjaik vannak a hím és nőnemű, valamint az egyes és többes számú nemek tekintetében.</p>


                <p>A héber szókincs ötvözi az ősi és a modern elemeket, magában foglalja a bibliai forrásokból származó szavakat, valamint a modern fogalmak és technológiák új kifejezéseit. A héber más nyelvekből is kölcsönzött szavakat, különösen az angolból és az arabból.</p>


                <p>A héber mint beszélt nyelv újjáéledése hozzájárult kulturális és társadalmi jelentőségéhez. Élénk nyelvvé vált, amelyet számos területen használnak, többek között az irodalomban, a médiában, az oktatásban és a mindennapi kommunikációban.</p>


                <p>A héber nyelv tanulása hozzáférést biztosít a gazdag zsidó irodalmi és vallási hagyományhoz, beleértve a héber Bibliát, a Talmudot és más klasszikus szövegeket. Emellett lehetővé teszi az izraeli kultúra és társadalom mélyebb megértését is.</p>
              
                <div className="sectionbottom">
                    <Link to="/magyar-heber-fordito">Magyar héber fordító</Link>

                    <img src={heber} alt="héber zászló"></img>
                    <img src={arrow} alt=">"></img>
                    <img src={magyar} alt="magyar zászló"></img>

                </div>

            </section>
        </>

    )
}

export default HeberMagyar;